import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import * as UserModule from '../../../Modules/UserModule';
import ActivateUserCompleteForm from '../Forms/_ActivateUserCompleteForm';
import ActivateUserBeginForm from '../Forms/_ActivateUserBeginForm';
import { withTranslation  } from 'react-i18next';

type Props = {
    history: any;
    match: {
        params: {
            token: string;
        };
    };
};

type ConnectedDispatch = {
    completeUserActivation: Function;
    beginUserActivation: Function;
};
type ConnectedProps = {
    t: Function;
};
type State = {
    activateUserCompleteVisible: boolean;
};

class ActivateUserComplete extends React.Component<Props & ConnectedDispatch & ConnectedProps, State> {
    constructor(props: Props & ConnectedDispatch & ConnectedProps) {
        super(props);
        this.state = {
            activateUserCompleteVisible: true
        };
        this.acitvateUser = this.acitvateUser.bind(this);
        this.acitvateUserBegin = this.acitvateUserBegin.bind(this);
    }
    private async acitvateUser(formData: UserModule.Types.PasswordResetRequest) {
        formData.token = this.props.match.params.token;
        await this.props.completeUserActivation(formData);
    }
    private async acitvateUserBegin(formData: UserModule.Types.RequestPasswordResetRequest) {
        await this.props.beginUserActivation(formData);
    }

    public render() {
        const { activateUserCompleteVisible } = this.state;
        const { t } = this.props;
        return (
            <div className="login__inner">
                <h1>
                    GPS
                    <br />
                    <span>Tracking</span>
                </h1>

                {activateUserCompleteVisible ? (
                    <ActivateUserCompleteForm
                        onSubmit={this.acitvateUser}
                        {...{ toggleFormsVisibility: () => this.setState({ activateUserCompleteVisible: !this.state.activateUserCompleteVisible }) }}
                    />
                ) : (
                    <ActivateUserBeginForm
                        onSubmit={this.acitvateUserBegin}
                        {...{ toggleFormsVisibility: () => this.setState({ activateUserCompleteVisible: !this.state.activateUserCompleteVisible }) }}
                    />
                )}
                <p>
                    <NavLink className="btn btn--clean btn--redirect" to={'/'}>
                        {t('goBackToLoginPage')}
                    </NavLink>
                </p>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        completeUserActivation: (formData: UserModule.Types.ActivateUserRequest) => dispatch(UserModule.Actions.completeUserActivation(formData)),
        beginUserActivation: (formData: UserModule.Types.RequestPasswordResetRequest) => dispatch(UserModule.Actions.beginUserActivation(formData))
    };
}
export default withTranslation ('forms')(
    connect(
        null,
        mapDispatchToProps
    )(ActivateUserComplete) as React.ComponentType<any>
) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/UserSigning/ActivateUser/ActivateUserComplete.tsx